<div style="height: 94vh;">

  <div style="width: 100%; height: 100%;">
    <h1>Мастер создания расчетов</h1>

    <mat-stepper linear #stepper>

      <mat-step [stepControl]="firstFormGroup" [editable]="isEditable">
        <ng-template matStepLabel>Выбор шаблона</ng-template>

        <mat-toolbar>
          <form [formGroup]="firstFormGroup" class="full-width-field">
            <mat-form-field appearance="fill" class="full-width-field">
              <input
                matInput
                formControlName="selected_module"
                placeholder="Поиск модуля"
                (input)="applyFilter($event)"
              />
            </mat-form-field>
          </form>
        </mat-toolbar>

        <div class="template-selection-container" style="display: flex; gap: 24px;">

          <!-- Список модулей -->
          <div class="module-list" style="flex: 1;">
            <table mat-table matSort [dataSource]="DataSourceTable" class="mat-elevation-z8">

              <!-- ID -->
              <ng-container matColumnDef="ID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                <td mat-cell *matCellDef="let row">{{ row.ID }}</td>
              </ng-container>

              <!-- Название -->
              <ng-container matColumnDef="ShortTitle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Название</th>
                <td mat-cell *matCellDef="let row">{{ row.ShortTitle }}</td>
              </ng-container>

              <!-- Уровень безопасности -->
              <ng-container matColumnDef="SecurityLevel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <fa-icon [icon]="faShieldHalved"></fa-icon>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.SecurityLevel }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="getrow(row)"
                class="selectable-row"
              ></tr>
            </table>
          </div>
          <!-- Список файлов выбранного модуля -->
          <div class="file-list" *ngIf="selected_module" style="width: 300px;">
            <h3>Файлы для «{{ selected_module.ShortTitle }}»</h3>
            <mat-list>
              <mat-list-item *ngFor="let file of filesList">
                <mat-icon mat-list-icon>insert_drive_file</mat-icon>
                <div mat-line>{{ file.ShortTitle }}</div>
                <button mat-icon-button (click)="previewFile(file)" matTooltip="Предпросмотр">
                  <mat-icon>visibility</mat-icon>
                </button>
                <a
                mat-icon-button
                [href]="
                  service.apiBase + '/redkey_download_file/' +
                  file.ID + '?jwt=' + storageService.getToken()
                "
                target="_blank"
                matTooltip="Скачать"
              >
                <mat-icon>cloud_download</mat-icon>
              </a>
              </mat-list-item>
            </mat-list>
          </div>

        </div>

        <div class="step-actions">
          <button mat-button (click)="exit()">Отмена</button>
          <button
            mat-button
            type="button"
            [disabled]="!selected_module"
            (click)="(+selected_module.ID === 5) ? openSpecialCalc() : stepper.next()"
          >
            Далее
          </button>
        </div>
      </mat-step>


      <!-- Шаг 2: Ввод параметров -->
      <mat-step [stepControl]="calc_form" [editable]="isEditable">
        <ng-template matStepLabel>Ввод параметров</ng-template>

        <form [formGroup]="calc_form" (ngSubmit)="save()" autocomplete="off">
          <div class="form-group">
            <label>Название</label>
            <input type="text" formControlName="ShortTitle" class="form-control" />
          </div>

          <div class="form-group">
            <label>Описание</label>
            <textarea
              formControlName="Description"
              cols="40"
              rows="5"
              class="form-control"
            ></textarea>
          </div>

          <div class="form-group">
            <label>Данные</label>
            <input
            type="file"
            class="form-control mb-3"
            (change)="onFileSelected($event); changeListener($event.target)"
          />
            <div class="scroll" *ngIf="records.length">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th *ngFor="let header of headers" class="text-center">{{ header }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of records">
                    <td *ngFor="let col of row" class="text-center">{{ col }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="step-actions">
            <button mat-raised-button color="accent" matStepperPrevious>Назад</button>
            <button mat-raised-button color="primary" type="submit">Сохранить</button>
            <button mat-raised-button color="warn" (click)="exit()">Отмена</button>
          </div>
        </form>
      </mat-step>

    </mat-stepper>
  </div>
</div>